import { buildSectionUrl, getSectionInnerHTML } from './utils';
import gallery from './gallery';
import sizeSelector from './sizeSelector';
import addToBagCta from './addToBagCta';
import bnpl from './bnpl';
import setActiveVariant from './setActive';
import sizeGuide from './sizeGuide';
import { colorSwatchClickTracking } from '../../components/GTMEvents';
import tracking from './tracking';
import finalSale from './finalSale';
import ConstructorTracking from '../../components/ConstructorTracking';

function calculateNextVariantId(nextColor) {
  // Get product data json
  const productJsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  // Get where is either 'value' or 'size' option placed in options, it depends on product type
  const sizeOrValueOption = productJsonData.type.includes('GIVEX') ? 'value' : 'size';
  const sizeOptionIndex = productJsonData.options.findIndex((option) => option.toLowerCase() === sizeOrValueOption);
  // Get variant-id selected
  const activeVariantId = document.querySelector('input[name="id"]').value;
  // Filter the specific variant
  const currentVariant = productJsonData.variants.find((variant) => variant.id === Number(activeVariantId));
  // Filter the next variant based on current color and current size option value chosen
  const nextVariant = productJsonData.variants.find(
    (variant) =>
      variant.options.includes(nextColor) && variant.options.includes(currentVariant.options[sizeOptionIndex]),
  );
  // Return specific variant-id
  return nextVariant?.id;
}

function getSectionsToRender() {
  const basisSections = [
    {
      id: 'pdp-gallery',
      section: 'pdp-gallery-content',
      selector: '.shopify-section',
    },
    {
      id: 'pdp-atc-price-tag',
      section: 'pdp-atc-price-tag',
      selector: '.shopify-section',
    },
  ];

  if (window.theme.country_iso === 'US') {
    // it creates a new array instead modifying existing array
    return basisSections.concat([
      {
        id: 'pdp-atc-size-selector',
        section: 'pdp-atc-size-selector',
        selector: '.shopify-section',
      },
      {
        id: 'pdp-incentives',
        section: 'pdp-incentives',
        selector: '.shopify-section',
      },
    ]);
  }
  return basisSections;
}

export function colorSwatchHandle(e) {
  const colorSwatch = e.target;
  const sectionsToRender = getSectionsToRender();
  const cnsTracking = new ConstructorTracking({ isValidCta: true });

  // Remove all active color-swatches
  document
    .querySelectorAll('.pdp-c-atc-color-selector__swatch-list>li>a')
    .forEach((colorSwatchItem) => colorSwatchItem.classList.remove('pdp-c-atc-color-selector__swatch-item--active'));

  // Apply active property on specific color-swatch clicked
  colorSwatch.classList.toggle('pdp-c-atc-color-selector__swatch-item--active');

  // Inform the new color value chosen
  document.querySelector('.pdp-c-atc-color-selector__value').textContent = colorSwatch.dataset.color;

  // Calculate next variant-id based on current size option selected and next color
  let nextVariantId = calculateNextVariantId(colorSwatch.dataset.marketColor);
  if (!nextVariantId) {
    nextVariantId = colorSwatch.dataset.variantId;
  }

  // Build a url to bring Shopify sections based on variant-id gotten from current size option and next color swatch item
  const url = buildSectionUrl(sectionsToRender, nextVariantId);

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('The PDP color change was not okay');
      }
      return response.json();
    })
    .then((data) => {
      sectionsToRender.forEach((sectionItem) => {
        const section = document.querySelector(`#${sectionItem.id}`);
        // Guard condition to exit gracefully when some section wasn't found. For example, pdp-incentives which is not rendered on international experiences
        if (!section) return;
        section.innerHTML = getSectionInnerHTML(data[sectionItem.section], sectionItem.selector);
      });

      // Repeating PDP Gallery JavaScript Logic
      gallery();

      // Defer this block because they are not user-visible tasks
      setTimeout(() => {
        // Check inventory only international experiences
        window.checkInventory.checkInventory(false, () => {
          sizeSelector();
          setActiveVariant();
          // Go over final sale
          finalSale();
        });
        // Re-initialize and update components
        bnpl();
        addToBagCta();
        sizeGuide();
        colorSwatchClickTracking(colorSwatch.dataset.color);
        tracking();
        // update Constructor Tracking variation data attribute
        cnsTracking.updateVariation();
      }, 0);
    })
    .catch((error) => {
      console.error(error.message);
    });
}

const colorSelector = () => {
  document.querySelectorAll('[id^="color_swatch_"]').forEach((colorSwatchTrigger) => {
    colorSwatchTrigger.addEventListener('click', colorSwatchHandle);
  });
};

export default colorSelector;
